import { useEffect, useState, RefObject } from 'react';
import { useBreakpoints } from 'common/hooks';
import { useIntersectionObserverCallback } from '@navi-toolbox/hooks';

export const useStickyLogic = (containerRef: RefObject<HTMLDivElement>) => {
  const { desktop, largeDesktop } = useBreakpoints() || {
    desktop: false,
    largeDesktop: false,
  };
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (desktop || largeDesktop) {
      setIsSticky(false);
    } else if (window?.scrollY > (containerRef?.current?.offsetTop ? containerRef?.current?.offsetTop : 0)) {
      setIsSticky(true);
    }
  }, [containerRef, desktop, largeDesktop]);

  useIntersectionObserverCallback(
    containerRef,
    {
      exit: () => {
        if (desktop || largeDesktop) {
          setIsSticky(false);
        } else if (
          !isSticky &&
          window?.scrollY > (containerRef?.current?.offsetTop ? containerRef?.current?.offsetTop : 0)
        ) {
          setIsSticky(true);
        }
      },
      enter: () => {
        if (isSticky) setIsSticky(false);
      },
    },
    [isSticky, setIsSticky, containerRef],
  );

  return { isSticky, setIsSticky };
};
